import React from "react";
import { Alert } from "antd";
import { snackbarStore } from "src/store/snackbarStore";

// severity = "success" | "info" | "warning" | "error"
const CustomSnackbar: React.FC = () => {
  const { snackbars, removeSnackbar } = snackbarStore();

  return (
    <div
      style={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      {snackbars.map((snackbar) => (
        <Alert
          key={snackbar.id}
          type={snackbar.severity}
          message={snackbar.message}
          showIcon
          closable
          onClose={() => removeSnackbar(snackbar.id)}
        />
      ))}
    </div>
  );
};

export default CustomSnackbar;
